import createHTTP from './create';
import { defaultApiEndpoint } from './config';

export default (axios, BalmUI) => ({
  /**
   *
   * @param {*} Vue
   * @param { apiEndpoint, withCredentials, setHttpConfig, requestHandler, requestErrorHandler, responseHandler, responseErrorHandler } options
   * NOTE: `responseHandler` 请求返回处理（必填）
   */
  install(Vue, options = {}) {
    const { apiEndpoint, withCredentials, setHttpConfig, ...handlers } =
      options;

    axios.defaults.baseURL = apiEndpoint || defaultApiEndpoint;
    axios.defaults.withCredentials = withCredentials || false; // NOTE: 跨域请求携带cookie

    setHttpConfig && setHttpConfig(axios.defaults);
    createHTTP({ axios, ...BalmUI }, handlers);

    Vue.prototype.$http = axios;
  }
});
